import React from 'react';
import { BannerContainer } from './styles';
import { Link } from 'react-router-dom';
import { userRoles } from 'constants/users';

export default function DemoAccountBanner({ userRole }) {
  let path = [userRoles.SUPER_ADMIN, userRoles.RESELLER].includes(userRole) ? '/payments' : '/plans';

  return (
    <BannerContainer>
      Demo data - <Link to={path}>Buy a test </Link> to active your account
    </BannerContainer>
  );
}
